import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TimeoutModal } from "./components/_TimeoutModal";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <TimeoutModal />
  </React.StrictMode>
);

reportWebVitals();
